import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import shallow from 'zustand/shallow';
import { useStore } from '../../../store';
import { useUISettings } from './queries/UISettings';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect } from 'react';

// eslint-disable-next-line react-refresh/only-export-components
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

export const QueryProvider: React.FC = ({ children }) => {
    const { setUIStartupLoaded } = useStore(
        store => ({
            setUIStartupLoaded: store.setUIStartupLoaded,
        }),
        shallow,
    );

    const { data } = useUISettings({}, queryClient);

    useEffect(() => {
        if (data) {
            setUIStartupLoaded(true);
        }
    }, [data, setUIStartupLoaded]);

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            <ReactQueryDevtools initialIsOpen={false} position="bottom" buttonPosition="bottom-right" />
        </QueryClientProvider>
    );
};
